// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:30:58

export default {
  "id": "bomby",
  "slug": "bomby",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5e9cf0bf87c34232b8e0c1732a605d29-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5e9cf0bf87c34232b8e0c1732a605d29/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bomby",
      "description": "In Bomby, your mission is simple but challenging—arrange the blocks provided to guide the adorable chicks back to their nest! Use logic, strategy, and creativity to solve each puzzle and ensure the chicks find their way home safely.",
      "instructions": "Pull the slingshot and shoot the bird into the nest",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "1player",
        "bird",
        "birds",
        "bomb",
        "slingshot"
      ]
    },
    "zh-CN": {
      "title": "炸弹",
      "description": "在《Bomby》中，你的任务简单但具有挑战性——将提供的方块排列好，引导可爱的小鸡回到它们的巢穴！运用逻辑、策略和创造力解决每个谜题，确保小鸡安全回家。",
      "instructions": "拉弓射鸟入巢",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "1玩家",
        "鸟",
        "鸟类",
        "炸弹",
        "弹弓"
      ]
    },
    "zh-TW": {
      "title": "雲母石",
      "description": "在《Bomby》中，你的任務簡單但挑戰性高——將提供的積木排列，引導可愛的小雞回到它們的巢穴！運用邏輯、策略和創意解開每個謎題，並確保小雞安全回到家裡。",
      "instructions": "拉開彈弓將鳥射入巢中",
      "genres": [
        "休閒",
        "射擊"
      ],
      "tags": [
        "1玩家",
        "鳥",
        "鳥群",
        "炸彈",
        "彈弓"
      ]
    },
    "zh-HK": {
      "title": "蟲彈",
      "description": "在《Bomby》中，你的任務簡單但挑戰性強——將提供的塊狀物重新排列，引導可愛的小雞返回它們的巢穴！運用邏輯、策略和創意解開每一個謎題，並確保小雞安全回到家裡。",
      "instructions": "拉開彈弓射鳥進入巢穴",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "1玩家",
        "鳥",
        "鳥群",
        "炸彈",
        "彈弓"
      ]
    },
    "ja": {
      "title": "ボンビー",
      "description": "ボンビであなたのミッションはシンプルだけど挑戦的です——提供されたブロックを使って、愛らしい雛たちを巣に導いてください！論理、戦略、そして創造力を使って、それぞれのパズルを解決し、雛たちが安全に家に帰れるようにしましょう。",
      "instructions": "リュートを引いて鳥を巣に射る",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "1プレイヤー",
        "鳥",
        "鳥たち",
        "爆弾",
        "蹴り投げ"
      ]
    },
    "ko": {
      "title": "콤비봇",
      "description": "보뮤에서는 간단하지만 도전적인 임무가 있습니다—제공된 블록을 사용하여 귀여운 새끼들을 집으로 돌아가도록 안내하세요! 각 패ズ를 해결하기 위해 논리, 전략, 창의력을 사용하고, 새끼들이 안전하게 집으로 돌아갈 수 있도록 보장하세요!",
      "instructions": "쇠사슬을 당겨 새를 둥지로 쏘아넣어주세요.",
      "genres": [
        "캐주얼",
        "쏘터"
      ],
      "tags": [
        "1플레이어",
        "새",
        "새들",
        "지뢰",
        "장대"
      ]
    },
    "fr": {
      "title": "Bomby",
      "description": "Dans Bomby, votre mission est simple mais délicate : arrangez les blocs fournis pour guider les charmantes poulettes de retour dans leur nid ! Utilisez la logique, la stratégie et la créativité pour résoudre chaque puzzle et assurez-vous que les poulettes trouvent leur chemin à la maison en toute sécurité.",
      "instructions": "Tirez sur le pistolet à élastique et tirez sur l'oiseau vers le nid",
      "genres": [
        "Facile",
        "Tiraureur"
      ],
      "tags": [
        "1 joueur",
        "oiseau",
        "oiseaux",
        "bombe",
        "arc-en-ciel"
      ]
    }
  }
};
